import { instance } from "../../lib/api";
import constant from "../../utils/CommonConstants";

export const FETCH_AVAILABLE_LEAD_KEYS = "FETCH_AVAILABLE_LEAD_KEYS";

export const getClientHandlerConfigs = ({ uuid, config }) => {
  return (dispatch) => {
    let url = `${process.env.DOMAINS.PAHAL}api/v0/filter-client-configs?jsession=true`;

    if (uuid) {
      url += `&profileUuid=${uuid}`;
    } else if (config) {
      url += `&urlPartial=${config}`;
    }

    return instance({
      url,
      method: "get",
      withCredentials: true,
    })
      .then((response) => {
        return response?.data?.data;
      })
      .catch((err) => {
        const errorMessage = constant.getErrorMessage(err);
        dispatch({
          type: constant.API_FAIL,
          errMsg: errorMessage,
        });
      });
  };
};

export const getClientHandlerConfigsById = ({ id }) => {
  return (dispatch) => {
    let url = `${process.env.DOMAINS.PAHAL}api/v0/client-config/${id}?jsession=true`;

    return instance({
      url,
      method: "get",
      withCredentials: true,
    })
      .then((response) => {
        return response?.data?.data;
      })
      .catch((err) => {
        const errorMessage = constant.getErrorMessage(err);
        dispatch({
          type: constant.API_FAIL,
          errMsg: errorMessage,
        });
      });
  };
};

export const createClientHandlerConfig = (configData) => {
  return (dispatch) => {
    const url = `${process.env.DOMAINS.PAHAL}api/v0/create-client-config?jsession=true`;

    return instance({
      url,
      method: "post",
      withCredentials: true,
      data: configData,
    })
      .then(() => {
        dispatch({
          type: constant.API_SUCCESS,
          errMsg: "Client handler configuration created successfully",
        });
        return true;
      })
      .catch((err) => {
        const errorMessage = constant.getErrorMessage(err);
        dispatch({
          type: constant.API_FAIL,
          errMsg: errorMessage,
        });
        return false;
      });
  };
};

export const updateClientHandlerConfig = (id, configData) => {
  return (dispatch) => {
    const url = `${process.env.DOMAINS.PAHAL}api/v0/client-config/update/${id}?jsession=true`;

    return instance({
      url,
      method: "post",
      data: configData,
      withCredentials: true,
    })
      .then(() => {
        dispatch({
          type: constant.API_SUCCESS,
          errMsg: "Client handler configuration updated successfully",
        });
        return true;
      })
      .catch((err) => {
        const errorMessage = constant.getErrorMessage(err);
        dispatch({
          type: constant.API_FAIL,
          errMsg: errorMessage,
        });
        return false;
      });
  };
};

export const getAvailableLeadKeys = () => {
  return (dispatch, getState) => {
    const { clientHandlerLeadKeys } = getState();
    if (clientHandlerLeadKeys && clientHandlerLeadKeys.length > 0) {
      return;
    }

    const url = `${process.env.DOMAINS.PAHAL}api/v0/valid-client-config-required-keys?jsession=true`;

    return instance({
      url,
      method: "get",
      withCredentials: true,
    })
      .then((response) => {
        const columns = response?.data?.data;

        dispatch({
          type: FETCH_AVAILABLE_LEAD_KEYS,
          payload: columns,
        });
      })
      .catch((err) => {
        const errorMessage = constant.getErrorMessage(err);
        dispatch({
          type: constant.API_FAIL,
          errMsg: errorMessage,
        });
      });
  };
};
